module.exports = __webpack_public_path__ + "static/img/home_erwei.283a516b.png";